import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Server, Shield, Cpu, Zap } from 'lucide-react';
import { PricingCard } from '../components/PricingCard';
import { VPSLocationSelector } from '../components/VPSLocationSelector';
import { DatacenterShowcase } from '../components/DatacenterShowcase';

export function VPSPage() {
  const { t } = useTranslation();

  const [location, setLocation] = useState<'game' | 'performance'>('game');

  const isGame = location === 'game';
  const isPerformance = location === 'performance';

  const vpsPlansGame = t('vps.plans.de.game', { returnObjects: true }) as any[];

  const vpsLinks = {
    game: [
      'https://my.synthohosting.net/index.php?rp=/store/vps-gaming/vpsgaming1',
      'https://my.synthohosting.net/index.php?rp=/store/vps-gaming/vpsgaming2',
      'https://my.synthohosting.net/index.php?rp=/store/vps-gaming/vpsgaming3',
      'https://my.synthohosting.net/index.php?rp=/store/vps-gaming/vpsgaming4',
      'https://my.synthohosting.net/index.php?rp=/store/vps-gaming/vpsgaming5',
      'https://my.synthohosting.net/index.php?rp=/store/vps-gaming/vpsgaming6',
      'https://my.synthohosting.net/index.php?rp=/store/vps-gaming/vpsgaming7',
      'https://my.synthohosting.net/index.php?rp=/store/vps-gaming/vpsgaming8',
      'https://my.synthohosting.net/index.php?rp=/store/vps-gaming/vpsgaming9',
      'https://my.synthohosting.net/index.php?rp=/store/vps-gaming/vpsgaming10'
    ]
  } as const;

  return (
    <div className="pt-16">

      {/* HERO */}
      <div className="relative bg-gradient-to-br from-blue-900 to-blue-700 text-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-4xl font-bold mb-6">
            {t('vps.title')}
          </h1>
          <p className="text-xl text-blue-100 max-w-3xl">
            {t('vps.subtitle')}
          </p>
        </div>
      </div>

      {/* CONTENUTO */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="grid md:grid-cols-3 gap-8 mb-16">

          <div className="bg-white p-6 rounded-xl shadow-lg">
            <Server className="w-12 h-12 text-blue-600 mb-4" />
            <h3 className="text-xl font-bold mb-2">
              {t('vps.features.hardware.title')}
            </h3>
            <p className="text-gray-600">
              {t('vps.features.hardware.description')}
            </p>
          </div>

          <div className="bg-white p-6 rounded-xl shadow-lg">
            <Shield className="w-12 h-12 text-blue-600 mb-4" />
            <h3 className="text-xl font-bold mb-2">
              {t('vps.features.protection.title')}
            </h3>
            <p className="text-gray-600">
              {t('vps.features.protection.description')}
            </p>
          </div>

          <div className="bg-white p-6 rounded-xl shadow-lg">
            <Cpu className="w-12 h-12 text-blue-600 mb-4" />
            <h3 className="text-xl font-bold mb-2">
              {t('vps.features.storage.title')}
            </h3>
            <p className="text-gray-600">
              {t('vps.features.storage.description')}
            </p>
          </div>

        </div>

        <VPSLocationSelector
          selectedLocation={location}
          onLocationChange={setLocation}
        />

        {isGame && Array.isArray(vpsPlansGame) && (
          <div className="space-y-10">
            <h2 className="text-2xl font-bold mb-2 text-center">
              {t('vps.plans.title')}
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-8">
              {vpsPlansGame.slice(0, 10).map((plan, index) => (
                <PricingCard
                  key={index}
                  {...plan}
                  buyLink={vpsLinks.game[index]}
                  isPopular={index === 6}
                />
              ))}
            </div>
          </div>
        )}

        {isPerformance && (
          <div className="flex items-center justify-center">
            <div className="w-full md:w-3/4 lg:w-2/3 text-center bg-gradient-to-r from-purple-600 to-purple-700 text-white px-8 py-12 rounded-2xl shadow-lg">
              <div className="flex items-center justify-center gap-3 mb-4">
                <Zap className="w-7 h-7" />
                <h2 className="text-2xl font-bold">
                  {t('vps.comingSoon.title')}
                </h2>
              </div>
              <p className="text-purple-100 text-lg">
                {t('vps.comingSoon.description')}
              </p>
            </div>
          </div>
        )}
      </div>

      <DatacenterShowcase />
    </div>
  );
}
